export default __webpack_public_path__ + "static/media/Zahl-1.20c03b85.webp";